
<script>
import config from '../../../../libs/config.js';
import { mapGetters, mapActions } from "vuex";
import _system from '../../../../libs/system';
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css';

  const countries = [
    'Searched on Google',
    'Referred by a friend',
    'Social Media',
    'Product Hunt',
    'Social Media Examiner',
    'Other'
  ]

   export default {
   name: "popupsAlertsAuthentication",
   data() {
      return {
         config,
         title: '',
         source: '',
         juphy_onboarding_whatsapp1: null
      }
   },
   computed: {
      ...mapGetters('session', ['isLoggedIn', 'getUser', 'getJwt', 'getRole', 'getUserDb']),
      ...mapGetters("htmlModals", ["modals"]),
      ...mapGetters('workspaces', ['currentWorkspace']),
   },
   methods: {
      ...mapActions("htmlModals", ["setSourceTitleRequest"]),
      whatsAppClicked(){
            localStorage.setItem("juphy_onboarding_whatsapp1", "true");
            this.juphy_onboarding_whatsapp1 = "true"
      }
   },
   mounted(){

      //whatsapp active ise onboardingi kaldir!
      this.juphy_onboarding_whatsapp1 = localStorage.getItem("juphy_onboarding_whatsapp1");
   },
   created(){}
}

</script>

<template>
<div v-if="!juphy_onboarding_whatsapp1" class="modalWrapper">
<div class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">

<div  class="ui grid centered stackable">
   <div class="ten wide column" >
      <div style="padding: 0;" @click="setConnectionError(false)"  class="ui basic segment right aligned">
<!--       <a style="background: rgba(0,0,0,0.6); position:relative; z-index:9999" class="ui black mini button">
      Close [ESC]</a> -->
      </div>
   </div>
</div>

   <div class="ui grid">
      <div style="background: #f1f1f1; border-radius: 0.5rem;" class="eleven wide column centered">
      <div class="ui basic huge segment">
         <div class="ui grid">
              <div style="text-align: center;" class="four wide column">
               <img data-aos="zoom-in" class="ui image fluid" style="margin: 0 auto; width: 120px; height: 100px; border-radius: 10px;" src="https://juphy.com/wp-content/uploads/2022/07/Screen-Shot-2022-07-21-at-5.45.24-AM.png" alt="">
               <div data-aos="zoom-in" class="ui basic small segment" style="font-style:italic; padding: 0; color: #aaaaaa;">
              <a href="https://www.linkedin.com/in/cembingool/" target="_blank"><i class="linkedin icon"></i> linkedin.com/cem</a>
               </div>
            </div>
            <div class="twelve wide column">
               <p data-aos="fade"> Hey {{getUser.name}} 👋,  Welcome!</p>
               <p data-aos="fade" data-aos-delay="600">I'm Cem, your Customer Success Manager.</p>
               <p  data-aos="fade" data-aos-delay="1200">Juphy is really easy to setup, just start with one of your social customer support channels 👇</p>
         
            <div  data-aos="fade" data-aos-delay="1800">

               <router-link to="/accounts/whatsapp">
               <button @click="whatsAppClicked()" style="background: #11bb19; margin-bottom: 1rem;" class="ui green large fluid button"><i class="icon whatsapp"></i> Connect WhatsApp Number </button>
               </router-link>

               <form id="auth" :action="'https://api.juphy.com/facebook/auth'" method="post">

               <input type="text" name="state" :value="JSON.stringify({ 'userId': getUser._id, 'workspaceId': currentWorkspace._id })" hidden>

               <input type="text" name="accessToken" :value="getJwt" hidden>
               <input type="text" name="client_id" :value="'220505862059842'" hidden>

               <input type="text" name="redirect_uri" :value="config.url + '/facebook/redirect'" hidden>

               <input type="text" name="response_type" :value="'code'" hidden>

               <input type="text" name="access_type" :value="'offline'" hidden>

               <input type="text" name="prompt" :value="'consent'" hidden>

               <input type="text" name="scope" :value="'pages_manage_engagement,pages_manage_ads,pages_manage_posts,pages_show_list,pages_manage_metadata,pages_read_engagement,ads_management,pages_messaging'" hidden>

               <button type="submit" value="Submit" class="ui facebook large button fluid"><i class="icon facebook"></i> Connect Facebook Page </button>
               </form>

               <form id="auth" class="ui form" :action="'https://graph.facebook.com/oauth/authorize'" method="get">

               <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>

               <input type="text" name="client_id" :value="'220505862059842'" hidden>

               <input type="text" name="redirect_uri" :value="config.url + '/instagram/redirect'" hidden>

               <input type="text" name="response_type" :value="'code'" hidden>

               <input type="text" name="access_type" :value="'offline'" hidden>

               <input type="text" name="prompt" :value="'consent'" hidden>

               <input type="text" name="scope" :value="'pages_manage_engagement,pages_manage_ads,pages_manage_posts,pages_show_list,pages_manage_metadata,pages_read_engagement,ads_management,pages_messaging,instagram_basic,instagram_manage_comments,instagram_manage_messages'" hidden>

               <button type="submit" value="Submit" style="background: rgba(0, 0, 0, 0) url('/img/social/instagram-background.jpg') repeat scroll 0% 0% / cover"  class="ui violet large fluid button"><i class="instagram icon"></i> Connect Instagram Account</button>

               </form>

               <form  id="auth" :action=" config.url + '/twitter/auth'" method="post">
                <input type="text" name="accessToken" v-model="getJwt" hidden>
                <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
                <button id="TwitterAddButton" type="submit" value="Submit" disabled class="ui twitter large fluid button"><i class="icon twitter"></i> Connect Twitter Account </button>
            </form>

            <form  id="auth" class="ui form center aligned" :action=" config.url + '/youtube/auth'" method="post">
            <input type="text" name="accessToken" v-model="getJwt" hidden>
            <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
            <button type="submit" value="Submit" style="background: #ff0000;"  class="ui violet large fluid button"><i class="youtube icon"></i> Connect YouTube Channel </button>
            </form>

         
            <form  id="auth" class="ui form" :action="'https://accounts.google.com/o/oauth2/auth'" method="get">

            <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>

            <input type="text" name="client_id" :value="'958501235262-dhr2s7rhl7m2s0iteec832vfr3r76ni1.apps.googleusercontent.com'" hidden>

            <input type="text" name="redirect_uri" :value="config.url + '/googlemybusiness/redirect'" hidden>

            <input type="text" name="response_type" :value="'code'" hidden>

            <input type="text" name="access_type" :value="'offline'" hidden>

            <input type="text" name="prompt" :value="'consent'" hidden>

            <input type="text" name="scope" :value="'https://www.googleapis.com/auth/plus.business.manage https://www.googleapis.com/auth/business.manage'" hidden>

            <button type="submit" value="Submit"  class="ui blue large fluid button"><i class="google icon"></i> Connect Google My Business Account </button>
            </form>

            <form id="auth" :action="'https://www.linkedin.com/oauth/v2/authorization'" method="get">
                <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>
                <input type="text" name="client_id" :value="'77wk7zhwz5hvg1'" hidden>
                <input type="text" name="redirect_uri" :value="'https://api.juphy.com/linkedin/redirect'" hidden>
                <input type="text" name="response_type" :value="'code'" hidden>
                <input type="text" name="scope" :value="'r_basicprofile r_emailaddress w_organization_social r_organization_social rw_organization_admin'" hidden>
                <button type="submit" value="Submit" class="ui linkedin large fluid button"><i class="icon linkedin"></i> Connect LinkedIn Business Page</button>
            </form>
         </div>

            </div>
         </div>
        
      </div>
   </div>
   </div>

   </div>
</div>
</template>


<style scoped>

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 999999999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modalWrapper div {
         z-index: 99999;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(30, 42, 58, 0.55) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/popups/alerts/authentication.vue